import List from "@elements/List/List";
import { ListItem } from "@elements/List/ListItem/ListItem";
import { HeaderMenuChildrens } from "@header/HeaderMenuConstants";
import { Link } from "react-router";
import { twMerge } from "tailwind-merge";

type MobileSubMenuItemsProps = {
  /**
   * Collection of submenus items to render.
   */
  submenus: HeaderMenuChildrens[];

  /**
   * Controls whether the submenu is visible.
   */
  dropdown: boolean;

  /**
   * Test ID used to identify the main container.
   */
  testId: string;

  /**
   * Defines the type and layout of the header menu.
   *
   * The menu type controls the responsive styling and behavior
   * applied to the list and its items.
   */
  type: string;
};

/**
 * Displays a dropdown list of submenu items.
 *
 * Renders each submenu item as a navigation link and
 * shows or hides the list based on the dropdown state.
 *
 * @param props - Component properties.
 * @returns The rendered submenu dropdown.
 */
export function SubMenuDropdown({
  submenus,
  dropdown,
  testId,
  type,
}: MobileSubMenuItemsProps) {
  return (
    <List
      testId={`${testId}-${type}-sublist`}
      className={twMerge(
        "lg:-mx-xxs lg:px-2",
        !dropdown && "hidden",
        dropdown &&
          "grid gap-5 lg:gap-0 lg:inline-flex lg:absolute lg:left-0 lg:w-full lg:justify-center lg:mt-2 lg:z-10 lg:bg-white-100 lg:shadow-6xl lg:rounded lg:p-2",
      )}
    >
      {submenus.map((submenu, index) => (
        <ListItem
          key={index}
          testId={`${testId}-${type}-${index}`}
          className="lg:pt-0"
        >
          <Link
            reloadDocument
            to={submenu.url}
            target={submenu.newTab ? "_blank" : "_self"}
            rel="noreferrer"
            className="block font-bold text-md tracking-tighter lg:text-base lg:py-2 lg:px-3"
          >
            {submenu.title}
          </Link>
        </ListItem>
      ))}
    </List>
  );
}
